var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"min-width":"1366px","max-width":"1920px"}},[_c('service-details-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }